module.exports = __webpack_public_path__ + "static/media/icon_edit_dark.04730a67.svg";